import React from "react";
import { Link } from "react-router-dom";
import categoriesData from "./categoriesData";
import { useLanguage } from "../contexts/LanguageContext";

// Correspondance entre les identifiants officiels TMDB
// et les clés présentes dans translation.json.
const TMDB_GENRE_TRANSLATION_KEYS = {
    "28": "action",
    "12": "adventure",
    "16": "animation",
    "35": "comedy",
    "80": "crime",
    "99": "documentary",
    "18": "drama",
    "10751": "family",
    "14": "fantasy",
    "36": "history",
    "27": "horror",
    "10402": "music",
    "9648": "mystery",
    "10749": "romance",
    "878": "sciFi",
    "10770": "tvMovie",
    "53": "thriller",
    "10752": "war",
    "37": "western",
};

const normalizeText = (value = "") =>
    String(value)
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .trim()
        .toLowerCase();

const My3FavoriteCategories = ({ category }) => {
    const { t } = useLanguage();

    if (!category) {
        return null;
    }

    const normalizedCategoryName = normalizeText(category.name);

    // La recherche par nom est conservée uniquement pour retrouver
    // l’image déjà configurée dans categoriesData.
    const categoryInfo = categoriesData.find(
        (item) =>
            normalizeText(item.name) === normalizedCategoryName
    );

    // La traduction utilise plutôt l’identifiant TMDB,
    // qui ne change jamais selon la langue.
    const translationKey =
        TMDB_GENRE_TRANSLATION_KEYS[String(category.id)];

    const completeTranslationKey = translationKey
        ? `categories.${translationKey}`
        : null;

    const translatedName = completeTranslationKey
        ? t(completeTranslationKey)
        : category.name;

    // Protection supplémentaire si une clé manque réellement.
    const displayedName =
        !translatedName ||
        translatedName.toLowerCase() ===
            completeTranslationKey?.toLowerCase()
            ? category.name
            : translatedName;

    const backgroundStyle = {
        backgroundImage: categoryInfo
            ? `url(${categoryInfo.image})`
            : "none",
    };

    return (
        <div
            className="previewMy3FavoriteCategories"
            style={backgroundStyle}
        >
            <Link to={`/categories/${category.id}`}>
                <div className="category-container">
                    <h4
                        className="categorieFavoriteEffect"
                        style={{
                            color: "#D90093",
                            fontSize: "0.8rem",
                        }}
                    >
                        {displayedName}
                    </h4>
                </div>
            </Link>
        </div>
    );
};

export default My3FavoriteCategories;